import React from 'react';
import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Box,
  CircularProgress,
} from '@mui/material';
import { formatDistanceToNow } from 'date-fns';
import { formatCurrency } from '../../utils/formatCurrency';
import { DASHBOARD_COLORS, sectionPaperSx, sectionTitleSx } from './dashboardStyles';

const TOP_LIMIT = 5;

const formatLastPurchase = (customer) => {
  const raw = customer.lastPurchaseDate || customer.lastTransactionDate;
  if (!raw) return '—';
  try {
    return formatDistanceToNow(new Date(raw), { addSuffix: true });
  } catch {
    return '—';
  }
};

const PendingPaymentsList = ({ customers, loading, onViewAll }) => {
  const rows = (customers || []).slice(0, TOP_LIMIT);

  return (
    <Paper elevation={0} sx={{ ...sectionPaperSx, height: '100%', minHeight: 300, display: 'flex', flexDirection: 'column' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography sx={{ ...sectionTitleSx, mb: 0 }}>Pending Payments (Top 5)</Typography>
        <Button size="small" onClick={onViewAll} sx={{ textTransform: 'none', fontWeight: 600, color: '#2563eb' }}>
          View All
        </Button>
      </Box>

      {loading ? (
        <Box flex={1} display="flex" alignItems="center" justifyContent="center">
          <CircularProgress size={28} />
        </Box>
      ) : rows.length === 0 ? (
        <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
          No pending payments.
        </Typography>
      ) : (
        <TableContainer sx={{ flex: 1 }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, color: DASHBOARD_COLORS.textMuted, py: 1, fontSize: '0.75rem' }}>
                  Customer
                </TableCell>
                <TableCell align="right" sx={{ fontWeight: 600, color: DASHBOARD_COLORS.textMuted, py: 1, fontSize: '0.75rem' }}>
                  Due Amount
                </TableCell>
                <TableCell align="right" sx={{ fontWeight: 600, color: DASHBOARD_COLORS.textMuted, py: 1, fontSize: '0.75rem' }}>
                  Last Purchase
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((c) => (
                <TableRow key={c.id} hover>
                  <TableCell sx={{ py: 1.5, borderColor: DASHBOARD_COLORS.border, maxWidth: 140 }}>
                    <Typography variant="body2" sx={{ fontWeight: 600 }} noWrap title={c.name}>
                      {c.name}
                    </Typography>
                  </TableCell>
                  <TableCell align="right" sx={{ py: 1.5, borderColor: DASHBOARD_COLORS.border }}>
                    <Box
                      component="span"
                      sx={{
                        display: 'inline-block',
                        fontWeight: 700,
                        fontSize: '0.8rem',
                        color: DASHBOARD_COLORS.danger,
                        bgcolor: '#fef2f2',
                        px: 1,
                        py: 0.35,
                        borderRadius: 1,
                      }}
                    >
                      {formatCurrency(c.balanceDue)}
                    </Box>
                  </TableCell>
                  <TableCell align="right" sx={{ py: 1.5, borderColor: DASHBOARD_COLORS.border, color: DASHBOARD_COLORS.textMuted, fontSize: '0.8rem' }}>
                    {formatLastPurchase(c)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Paper>
  );
};

export default PendingPaymentsList;
